export const BUSINESS_UNIT_LIST = [
  { value: 'products', label: 'All' },
  { value: 'seg', label: 'PreK-12' },
  { value: 'he', label: 'Higher Ed' },
];

export const BUSINESS_UNIT_MAP = {
  'prek-12': 'seg',
  highered: 'he',
};
